import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW1502Model } from './kymw1502.model';
import { MarkFileRequestModel } from './vo/mark-file-request.model';

/**
 * 適用期間指定画面を管理するクラス
 *
 * @export KYMW1502Component
 * @class KYMW1502Component
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-kymw1502',
  templateUrl: 'kymw1502.component.html',
  styleUrls: ['kymw1502.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1502Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;

  kymw1502Model: KYMW1502Model = new KYMW1502Model();

  // 親画面への連携用
  setKYMW1502Parameter: Function;

  /**
   *Creates an instance of KYMW1502Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1502Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1502Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1502';

  }

  /**
   * コンテキストメニュー「適用期間の修正」用に、
   * 親画面からのパラメタを受け取るためのメソッド
   *
   * @param {MarkFileRequestModel} param 受け渡すデータ
   * @memberof KYMW1502Component
   */
  public setInterfaceParam(param: MarkFileRequestModel): void {
    // 画面表示時保持用
    this.kymw1502Model.vo = param;

    if (param.StartOrderCode === '指定なし') {
      this.kymw1502Model.notDesignateStart = true;
      this.kymw1502Model.startOrderCode = '';
      this.kymw1502Model.startOrderCodeEnabled = false;
    } else {
      this.kymw1502Model.notDesignateStart = false;
      this.kymw1502Model.startOrderCode = param.StartOrderCode;
      this.kymw1502Model.startOrderCodeEnabled = true;
    }

    if (param.EndOrderCode === '指定なし') {
      this.kymw1502Model.notDesignateEnd = true;
      this.kymw1502Model.endOrderCode = '';
      this.kymw1502Model.endOrderCodeEnabled = false;
    } else {
      this.kymw1502Model.notDesignateEnd = false;
      this.kymw1502Model.endOrderCode = param.EndOrderCode;
      this.kymw1502Model.endOrderCodeEnabled = true;
    }
  }

  /**
   * チェックボックス「使用開始 指定無し」クリックイベントリスナ
   * テキストボックス「使用開始 受注コード」の活性、非活性を切替える
   */
  public eventNotDesignateStart_CLICKHandler(): void {
    if (this.kymw1502Model.notDesignateStart) {
      this.kymw1502Model.startOrderCodeEnabled = false;
      // 入力内容をクリア
      this.kymw1502Model.startOrderCode = '';
      this.txt_StartOrderCode.setOrderCode('');
    } else {
      this.kymw1502Model.startOrderCodeEnabled = true;
    }
  }

  /**
   * チェックボックス「使用終了 指定無し」クリックイベントリスナ
   * テキストボックス「使用終了 受注コード」の活性、非活性を切替える
   */
  public eventNotDesignateEnd_CLICKHandler(): void {
    if (this.kymw1502Model.notDesignateEnd) {
      this.kymw1502Model.endOrderCodeEnabled = false;
      this.kymw1502Model.endOrderCode = '';
      this.txt_EndOrderCode.setOrderCode('');
    } else {
      this.kymw1502Model.endOrderCodeEnabled = true;
    }
  }

  /**
   * ボタン「設定」クリックイベントリスナ
   */
  public eventSetMarkFilePeriod_CLICKHandler(): void {

    const vo = new MarkFileRequestModel();

    vo.MarkCode = this.kymw1502Model.vo.MarkCode;
    vo.MarkCodeBranch = this.kymw1502Model.vo.MarkCodeBranch;
    vo.StartOrderCode = this.kymw1502Model.startOrderCode;
    vo.EndOrderCode = this.kymw1502Model.endOrderCode;

    this.txt_StartOrderCode.setOrderCode(vo.StartOrderCode);
    this.txt_EndOrderCode.setOrderCode(vo.EndOrderCode);

    // 入力チェック
    if (!this.inputCheckSetMarkFilePeriod(vo)) {
      return;
    }

    this.setKYMW1502Parameter(vo);

    this.closeFunction();
  }

  /**
   * 適用期間指定の入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheckSetMarkFilePeriod(vo: MarkFileRequestModel): boolean {
    // 「使用開始 受注コード」チェック（使用開始のチェックボックス「指定なし」が OFF の場合のみ）
    if (!this.kymw1502Model.notDesignateStart) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(vo.StartOrderCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['使用開始 受注コード']);
        return false;
      }

      // 存在チェック
      if (PlessViewUtilsSub.isEmpty(this.txt_StartOrderCode.selectedCatalogID)) {
        this.dialogService.openAlertGetMessage('E0122', ['使用開始 受注コード']);
        return false;
      }
    }

    // 「使用終了 受注コード」チェック（使用終了のチェックボックス「指定なし」が OFF の場合のみ）
    if (!this.kymw1502Model.notDesignateEnd) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(vo.EndOrderCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['使用終了 受注コード']);
        return false;
      }

      // 存在チェック
      if (PlessViewUtilsSub.isEmpty(this.txt_EndOrderCode.selectedCatalogID)) {
        this.dialogService.openAlertGetMessage('E0122', ['使用終了 受注コード']);
        return false;
      }
    }

    // 「受注コード」チェック（使用開始／終了のチェックボックス「指定なし」が OFF の場合のみ）
    if ((!this.kymw1502Model.notDesignateStart) && (!this.kymw1502Model.notDesignateEnd)) {
      if (Number(vo.StartOrderCode) > Number(vo.EndOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return false;
      }
    }

    return true;
  }
}
